// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Qp-z","modalContent":"Rp-z","header":"Sp-z","close":"Tp-z"};